import React, { useEffect } from "react";
import ADR from "../components/sections/ADR";
import FinalCTA from "../components/sections/FinalCTA";
import useSEO from "../hooks/useSEO";
import { useLang } from "../context/LanguageContext";

export default function ADRPage() {
  const { lang } = useLang();
  useSEO({
    title: lang === "pl" ? "ADR — Doradztwo DGSA — LK LOG" : "ADR — DGSA consulting — LK LOG",
    description:
      lang === "pl"
        ? "Certyfikowany doradca DGSA. Przewóz towarów niebezpiecznych, raporty roczne ADR, audyty, szkolenia i wdrożenia procedur."
        : "Certified DGSA adviser. Dangerous goods transport, annual ADR reports, audits, training and procedure roll-outs.",
    path: "/adr",
    lang,
  });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <main data-testid="adr-page" className="pt-20">
      <ADR />
      <FinalCTA />
    </main>
  );
}
